import styled from 'styled-components'

import { helpers } from 'styles'

import { Row as DefaultRow } from 'components/Lists'

export const Row = styled(DefaultRow)`
	padding: 8px;
	font-size: ${helpers.font.size.base};

	&:last-child {
		padding-bottom: ${helpers.spacing.large};
	}
`
